import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export default function UnauthorizedPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6">
      <div className="text-center max-w-sm">
        <div className="w-20 h-20 rounded-full bg-red-500/10 border border-red-500/20
                        flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-red-400" fill="none" viewBox="0 0 24 24"
               stroke="currentColor" strokeWidth={1.8}>
            <path strokeLinecap="round" strokeLinejoin="round"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h1 className="text-3xl font-bold text-white mb-3">Access Denied</h1>
        <p className="text-[#E4E4E7] text-lg mb-2">
          This area is restricted to administrators.
        </p>
        {user && (
          <p className="text-[#52525B] text-sm mb-8">
            Signed in as <span className="text-[#71717A]">{user.email}</span>
            {' '}· role: <span className="text-[#71717A]">{user.role}</span>
          </p>
        )}
        <div className="flex gap-3 justify-center flex-wrap">
          <button onClick={() => navigate('/')}
                  className="mp-btn mp-btn-primary px-6 py-2.5">
            Go Home
          </button>
          <button onClick={() => navigate(-1)}
                  className="mp-btn mp-btn-ghost px-6 py-2.5">
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
